export enum GsdRoles {
    SuperAdmin = 'SuperAdmin',
    Admin='Admin',
    ProposalUser = 'Proposal.User',
    ProposalAdmin= 'Proposal.Admin',
    TemplateUser= 'Template.User',
    TemplateAdmin= 'Template.Admin',
    SkillUser= 'Skill.User',
    SkillAdmin= 'Skill.Admin',
    Leadership= 'Leadership',
    CompetencyLeader = 'CompetencyLeader',
    SubCompetencyLeader='SubCompetencyLeader',
    PMORole = 'PMORole'
}